var EEHIROOT=document.getElementById('eehi-colostrum-cost-per-serving')||document;

(function(){
  var sizes=EEHIROOT.querySelectorAll('.size'), rows=EEHIROOT.querySelectorAll('.delrow');
  function money(n){return '$'+n.toFixed(2);}
  function selSize(){return EEHIROOT.querySelector('.size.sel');}
  function mode(){return EEHIROOT.querySelector('.delrow.sel').dataset.mode;}
  function setAll(id,val){EEHIROOT.querySelectorAll(id).forEach(function(e){e.textContent=val;});}
  function update(){
    var s=selSize(), price=parseFloat(s.dataset.price), variant=s.dataset.variant, nm=s.querySelector('.nm').textContent;
    var pay=mode()==='sub'?price*0.8:price;
    document.getElementById('onePr').textContent=money(price);
    var o2=document.getElementById('onePr2'); if(o2)o2.textContent=money(price);
    document.getElementById('btnPr').textContent=money(pay);
    var b2=document.getElementById('btnPr2'); if(b2)b2.textContent=money(pay);
    document.getElementById('stickPr').textContent='· '+nm+' '+money(price);
    var plan=mode()==='sub'?('?selling_plan='+(s.dataset.plan||'')):'';
    var href='/cart/'+variant+':1'+plan;
    document.getElementById('buyBtn').setAttribute('href',href);
    var bb2=document.getElementById('buyBtn2'); if(bb2)bb2.setAttribute('href',href);
  }
  // sync selection across both buy boxes by price
  sizes.forEach(function(s){s.addEventListener('click',function(){
    var pr=s.dataset.price;
    sizes.forEach(function(x){x.classList.toggle('sel', x.dataset.price===pr);});
    update();
  });});
  rows.forEach(function(r){r.addEventListener('click',function(){
    var m=r.dataset.mode;
    rows.forEach(function(x){x.classList.toggle('sel', x.dataset.mode===m);});
    update();
  });});
  EEHIROOT.querySelectorAll('.faq button').forEach(function(b){b.addEventListener('click',function(){var f=b.parentElement,a=f.querySelector('.a'),open=f.classList.contains('open');EEHIROOT.querySelectorAll('.faq.open').forEach(function(o){o.classList.remove('open');o.querySelector('.a').style.maxHeight=null;});if(!open){f.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}});});
  update();
})();


(function(){
 function num(id){var v=parseFloat(document.getElementById(id).value);return isNaN(v)?0:v;}
 function money(n){return '$'+(Math.round(n*100)/100).toFixed(2);}
 function run(){
   var price=num('c_price'),tg=num('c_grams'),dg=num('c_daily');
   var servings = dg>0 ? tg/dg : 0;
   var cps = servings>0 ? price/servings : 0;
   var cpg = tg>0 ? price/tg : 0;
   var std = cpg*2;
   document.getElementById('o_serv').textContent = servings ? servings.toFixed(0) : '—';
   document.getElementById('o_cps').textContent = cps ? money(cps) : '—';
   document.getElementById('o_cpg').textContent = cpg ? money(cpg) : '—';
   document.getElementById('o_std').textContent = std ? money(std) : '—';
 }
 ['c_price','c_grams','c_daily'].forEach(function(id){document.getElementById(id).addEventListener('input',run);});
 run();
})();